"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const CustomTypeModelFieldType = {
  Boolean: "Boolean",
  Color: "Color",
  Date: "Date",
  Embed: "Embed",
  GeoPoint: "GeoPoint",
  Group: "Group",
  Image: "Image",
  IntegrationFields: "IntegrationFields",
  Link: "Link",
  Number: "Number",
  Select: "Select",
  Slices: "Slices",
  StructuredText: "StructuredText",
  Text: "Text",
  Timestamp: "Timestamp",
  UID: "UID",
  Range: "Range",
  Separator: "Separator",
  LegacySlices: "Choice"
};
exports.CustomTypeModelFieldType = CustomTypeModelFieldType;
//# sourceMappingURL=types.cjs.map
